/**
 * Parked orders — fetching, parking and bringing back.
 *
 * Separate from the sheet that displays them so that editing the list does not
 * reload the hook's state, and so the query keys live somewhere a screen can
 * import without pulling in a dialog.
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '../../lib/api.js';

export function useHeldOrders() {
  const client = useQueryClient();

  const list = useQuery({
    queryKey: ['held'],
    queryFn: () => api.get('/pos/orders/held/list'),
    staleTime: 30_000,
  });

  const hold = useMutation({
    mutationFn: (body) => api.post('/pos/orders/hold', body),
    onSuccess: () => client.invalidateQueries({ queryKey: ['held'] }),
  });

  const recall = useMutation({
    mutationFn: (id) => api.post(`/pos/orders/held/${id}/recall`),
    onSuccess: () => client.invalidateQueries({ queryKey: ['held'] }),
  });

  return { held: list.data?.orders ?? [], loading: list.isLoading, hold, recall };
}
